'use strict';

/* eslint-disable global-require */

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./AppContainer.prod');
} else {
  module.exports = require('./AppContainer.dev');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/lib/AppContainer.js
// module id = ./node_modules/react-hot-loader/lib/AppContainer.js
// module chunks = 0